module.exports = __webpack_public_path__ + "static/media/cloudy_weather.7400a0ab.png";